import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from '@mui/material';

export default function ConfirmDeleteModal({
  open,
  title = "Conferma Eliminazione",
  message = "Sei sicuro di voler eliminare questo elemento?",
  onCancel,
  onConfirm
}) {
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>{title}</DialogTitle>

      <DialogContent>
        <DialogContentText>
          {message}
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button onClick={onCancel}>Annulla</Button>
        <Button color="error" variant="contained" onClick={onConfirm}>
          Elimina
        </Button>
      </DialogActions>
    </Dialog>
  );
}